import { __decorate, __metadata } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Dialog } from 'element-ui';
import _ from 'lodash';
import PsInput from 'library-components/components/Input/Input.vue';
import PtPopper from '@patsnap-biz/popper';
import '@patsnap-biz/popper/lib/style';
import { validateLoginPwd } from 'library-components/utils/validator';
import 'tippy.js/dist/border.css';
let GoogleLoginPassWordDialogImpl = class GoogleLoginPassWordDialogImpl extends Vue {
    constructor() {
        super(...arguments);
        this.password = '';
        this.tippyJsPwdErrorInstance = null;
        this.capsLock = false;
    }
    onSubmit() {
        this.$emit('submit', {
            password: this.password,
        });
    }
    get ValidateLoginPwd() {
        return validateLoginPwd(this, _.trim(this.password));
    }
    onPasswordInputChange() {
        this.tippyJsPwdErrorInstanceToggle();
    }
    tippyJsPwdErrorInstanceToggle() {
        if (this.ValidateLoginPwd) {
            this.tippyJsPwdErrorInstance[0].setContent(this.ValidateLoginPwd);
            this.tippyJsPwdErrorInstance[0].show();
            return;
        }
        if (this.capsLock) {
            this.tippyJsPwdErrorInstance[0].setContent(this.$t('passport.capslockTurnedOn'));
            this.tippyJsPwdErrorInstance[0].show();
            return;
        }
        this.tippyJsPwdErrorInstance[0].hide();
    }
    onPasswordKeyup(e) {
        // const keyCode = e.keyCode || e.which
        if (e.getModifierState) {
            if (e.getModifierState('CapsLock') && !e.shiftKey) {
                this.capsLock = true;
            }
            else {
                this.capsLock = false;
            }
            this.tippyJsPwdErrorInstanceToggle();
        }
    }
    mounted() {
        this.tippyJsPwdErrorInstance = PtPopper.tippyJs.delegate('.google-login-password-dialog', {
            target: '.google-login-password-dialog__content-input input',
            trigger: 'manual',
            content: this.$t('passport.pwdEnterInvalidCharacters'),
            theme: 'warning',
            placement: 'bottom-start',
            zIndex: 10000,
            delay: 150,
            interactive: true,
            popperOptions: {
                popperClass: 'google-popper-container',
            },
            appendTo: () => this.$el.querySelector('.google-login-password-dialog__content-input'),
        });
    }
};
__decorate([
    Prop({
        type: String,
    }),
    __metadata("design:type", String)
], GoogleLoginPassWordDialogImpl.prototype, "account", void 0);
__decorate([
    Prop({
        type: String,
    }),
    __metadata("design:type", String)
], GoogleLoginPassWordDialogImpl.prototype, "loginErrorMsg", void 0);
GoogleLoginPassWordDialogImpl = __decorate([
    Component({
        components: {
            ElDialog: Dialog,
            PsInput,
        },
    })
], GoogleLoginPassWordDialogImpl);
export { GoogleLoginPassWordDialogImpl };
